<template>
  <div>
    <DownloadChart @click="downloadCanvas('sectorChart', 'titleSectorChart')" />
    <div class="p-1" ref="sectorChart">
      <h3 ref="titleSectorChart" class="hidden mt-4 text-lg">
        Corruption Cases By Sector
      </h3>
      <BarChart
        class="text-white"
        :width="width"
        :height="height"
        :chart-data="chartData"
        :options="options"
      />
      <div v-if="showPercentages" class="mt-4">
        <div class="flex items-center">
          <div class="w-2 h-2 bg-private rounded-full mr-3"></div>
          <span class="truncate">Private</span>
          <div
            class="h-px flex-1 border border-r border-dashed border-gray-300 mx-3 xl:hidden"
          ></div>
          <span class="font-medium xl:ml-auto">
            {{ ((private_sector / totalCases) * 100) | percentage }}
          </span>
        </div>
        <div class="flex items-center mt-2">
          <div class="w-2 h-2 bg-public rounded-full mr-3"></div>
          <span class="truncate">Public</span>
          <div
            class="h-px flex-1 border border-r border-dashed border-gray-300 mx-3 xl:hidden"
          ></div>
          <span class="font-medium xl:ml-auto">
            {{ ((public_sector / totalCases) * 100) | percentage }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from "./Charts/BarChart";
import axios from "axios";

export default {
  components: {
    BarChart
  },
  props: {
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    showPercentages: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      private_sector: 0,
      public_sector: 0,
      totalCases: 0
    };
  },
  computed: {
    filterParams() {
      return this.$store.state.filtersMenu.selectedFilters;
    },
    chartData() {
      return {
        labels: ["Private", "Public"],
        datasets: [
          {
            data: [this.private_sector, this.public_sector],
            backgroundColor: ["#19637a", "#1db097"],
            hoverBackgroundColor: ["#19637a", "#1db097"],
            borderWidth: 1,
            borderColor: this.$store.state.main.darkMode ? "#303953" : "#fff",
            pointBackgroundColor: "white",
            pointBorderColor: "#249EBF"
          }
        ]
      };
    },
    options() {
      return {
        legend: {
          display: false
        },
        cutoutPercentage: 80,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: true
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: false
              }
            }
          ]
        },
        tooltips: {
          enabled: true,
          mode: "single",
          callbacks: {
            label: function(tooltipItems) {
              return tooltipItems.yLabel;
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 210
      };
    }
  },
  watch: {
    "$store.state.filtersMenu.count": {
      handler: function() {
        this.run();
      }
    }
  },
  mounted() {
    this.run();
  },
  methods: {
    run() {
      axios
        .get(`${window.host}/api/cases-sectors`, {
          params: this.filterParams
        })
        .then(response => {
          if (response.data) {
            this.private_sector = response.data.private_sector;
            this.public_sector = response.data.public_sector;
          }
        });

      axios
        .get(`${window.host}/api/cases-count`, {
          params: this.filterParams
        })
        .then(response => {
          if (response.data) {
            this.totalCases = response.data.no_of_cases;
          }
        });
    }
  }
};
</script>

<style scoped>
.bg-private {
  background-color: #19637a;
}
.bg-public {
  background-color: #1db097;
}
</style>
